import { render, staticRenderFns } from "./InputModal.vue?vue&type=template&id=28a80e02"
import script from "./InputModal.vue?vue&type=script&lang=js"
export * from "./InputModal.vue?vue&type=script&lang=js"
import style0 from "./InputModal.vue?vue&type=style&index=0&id=28a80e02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports